'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _IconBase = require('./IconBase.js');

var _IconBase2 = _interopRequireDefault(_IconBase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var PlotCarpetIcon = function PlotCarpetIcon(props) {
    return _react2.default.createElement(
        _IconBase2.default,
        _extends({ viewBox: '0 0 32 32' }, props),
        _react2.default.createElement('path', { d: 'M9 4.063h22.25c.375.125.625.563.438.938-2.5 7.313-5 14.625-7.563 21.938-.125.5-.563.875-1.063 1H.812c-.438-.063-.688-.563-.5-.938 2.5-7.313 5.063-14.625 7.563-21.938.125-.5.625-.875 1.125-1m.375 1.875a83.164 83.164 0 0 1-1.25 3.625h3.688c.438-1.188.813-2.438 1.25-3.625H9.375m5.5 0a83.164 83.164 0 0 1-1.25 3.625c1.25 0 2.438.063 3.688 0a83.164 83.164 0 0 1 1.25-3.625h-3.688m5.5 0a83.164 83.164 0 0 1-1.25 3.625h3.688a83.164 83.164 0 0 1 1.25-3.625h-3.688m5.5 0a83.164 83.164 0 0 1-1.25 3.625h3.563c.125.063.125-.063.188-.188.375-1.125.813-2.313 1.188-3.438h-3.688M7.5 11.438c-.438 1.188-.813 2.438-1.25 3.625h3.688a83.164 83.164 0 0 1 1.25-3.625H7.5m4.25 3.625h3.625c.438-1.188.875-2.438 1.313-3.625H13c-.438 1.188-.813 2.438-1.25 3.625m6.75-3.625c-.438 1.188-.813 2.438-1.25 3.625h3.625c.438-1.188.875-2.438 1.313-3.625H18.5m5.5 0a82.752 82.752 0 0 0-1.25 3.625h3.625c.438-1.188.875-2.438 1.313-3.625H24M4.375 20.563H8a82.752 82.752 0 0 0 1.25-3.625H5.625a82.752 82.752 0 0 0-1.25 3.625m6.75-3.625a82.752 82.752 0 0 0-1.25 3.625H13.5a82.752 82.752 0 0 0 1.25-3.625h-3.625m5.5 0a82.752 82.752 0 0 0-1.25 3.625H19a82.752 82.752 0 0 0 1.25-3.625h-3.625m5.5 0a82.752 82.752 0 0 0-1.25 3.625H24.5a82.752 82.752 0 0 0 1.25-3.625h-3.625m-18.375 5.5c-.438 1.188-.875 2.438-1.313 3.625h3.688c.438-1.188.813-2.438 1.25-3.625-1.188 0-2.438-.063-3.625 0m5.438 0a83.164 83.164 0 0 1-1.25 3.625h3.688c.438-1.188.813-2.438 1.25-3.625-1.188 0-2.438-.063-3.688 0m5.5 0a83.164 83.164 0 0 1-1.25 3.625h3.688c.438-1.188.813-2.438 1.25-3.625-1.25 0-2.438-.063-3.688 0m5.5.125c-.438 1.188-.813 2.313-1.25 3.5h3.688a82.752 82.752 0 0 0 1.25-3.625h-3.625c-.063-.063-.063.063-.063.125z' })
    );
};

exports.default = PlotCarpetIcon;


//////////////////
// WEBPACK FOOTER
// ./node_modules/plotly-icons/lib/components/PlotCarpetIcon.js
// module id = 653
// module chunks = 0